/* stylelint-disable no-descending-specificity */
/* stylelint-disable property-no-vendor-prefix */
import styled, { css } from "styled-components"
import Button from "components/atoms/Button"

const transtionsStyles = css`
  transition: all 0.2s;
  touch-action: manipulation;
`
const actionStyles = css`
  &:focus {
    outline: 0;
  }
  
  &:focus-visible {
  outline: 2px solid ${({ theme }) => theme.color.septenary03};
  outline-offset: 2px;
  }

  &:placeholder-shown + label {
    cursor: text;
    max-width: 66.66%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform-origin: left bottom;
    transform: translate(2.4rem, 3.8rem) scale(1.5);
  }

  &:not(:placeholder-shown) + label,
  &:focus + label {
    transform: translate(2.4rem, 0) scale(1);
    cursor: pointer;
  }

  &:focus::-webkit-input-placeholder {
    opacity: 1;
  }

  &::-webkit-input-placeholder {
    opacity: 0;
    transition: inherit;
  }
`
const textStyles = css`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.l};
  line-height: 1.78;
  color: ${({ theme }) => theme.color.secondary01};
`
const inputStyles = css`
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.secondary04};
  -webkit-appearance: none;
  border-radius: 0;
  cursor: text;
  padding: 1.1rem 2.4rem;
  background-color: transparent;
  margin-bottom: 4.8rem;

  ${({ iserror }) =>
    iserror &&
    css`
      border-color: ${({ theme }) => theme.color.tertiary03};
    `}

  ${textStyles}
  ${actionStyles}
  ${transtionsStyles}
`

const StyledButton = styled(Button)`
  align-self: flex-end;
`
const StyledField = styled.div`
  display: flex;
  flex-flow: column-reverse;
  position: relative;
`

const StyledLabel = styled.label`
  font-size: ${({ theme }) => theme.font.size.xs};
  font-family: ${({ theme }) => theme.font.family.body};
  color: ${({ theme }) => theme.color.secondary02};
  width: max-content;

  ${transtionsStyles}
`

const StyledInput = styled.input`
  ${inputStyles}
`

const StyledPhoneInput = styled.input`
  ${inputStyles}
  margin-left: 12.9rem;
  padding-left: 0.8rem;
  &:placeholder-shown + label {
    transform: translate(2.4rem, 0);
  }

  &::-webkit-input-placeholder {
    opacity: 1;
  }
`

const StyledTextarea = styled.textarea`
  ${inputStyles}
  ${actionStyles}
  resize: none;
`

const StyledError = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.tertiary03};
  position: absolute;
  left: 2.4rem;
  bottom: 2.4rem;
  height: 2rem;
`
const StyledPhoneInputCountry = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  position: absolute;
  top: 3rem;
  width: 105px;
  border-bottom: 1px solid ${({ theme }) => theme.color.secondary04};
`
const StyledCountrySelect = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  border: 0;
  opacity: 0;
  cursor: pointer;
`
const StyledVisuallyHiddenLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`  
const StyledForm = styled.form`
  width: 100%;
  max-width: 46.8rem;
  display: flex;
  flex-direction: column;

  ${({ type }) =>
    type &&
    type === "secondary" &&
    css`
      margin-bottom: 3.2rem;

      ${({ theme }) => theme.mq.medium} {
        max-width: 36.8rem;
        margin-bottom: 0;
      }

      ${StyledInput}, ${StyledPhoneInput}, ${StyledPhoneInputCountry}, ${StyledTextarea} {
        border: solid 1px ${({ theme }) => theme.color.secondary04};
        font-size: ${({ theme }) => theme.font.size.s};
      }

      ${StyledInput}, ${StyledPhoneInput}, ${StyledPhoneInputCountry} {
        height: 4rem;
        padding: 1.2rem 0.8rem;
        margin-bottom: 2.4rem;
      }

      ${StyledTextarea} {
        padding: 1.2rem 0.8rem;
        height: 8.8rem;

        & ~ ${StyledError} {
          bottom: 2.8rem
        }
       }

      ${StyledInput}, ${StyledTextarea} {

        &:placeholder-shown + label {
          transform: translate(1.2rem, 2.8rem) scale(1.2);
        }

        &:not(:placeholder-shown) + label,
        &:focus + label {
          font-weight: ${({ theme }) => theme.font.weight.semiBold};
          transform: translate(0, -4px) scale(1);
          cursor: pointer;
        }
       }


       ${StyledPhoneInput} {
        margin-left: 10.9rem;
        margin-bottom: 5.4rem;
        &:not(:placeholder-shown) + label,
        &:placeholder-shown + label {
          transform: translate(0, -4px);
        }

        & ~ ${StyledError} {
          bottom: 2.8rem
        }
       }

       ${StyledPhoneInputCountry} {
        top: 1.5rem;

        > div {
          padding: 0.8rem;

          &:after {
            right: 0.8rem;
          }
        }
       }

       ${StyledError} {
         left: 0;
         bottom: 0.4rem;
       }
    `}
`

const StyledButtonWrapper = styled.div`
  display: flex;

  > *:first-child {
    margin-left: auto;
    margin-right: 1.6rem;

    ${({ asPage }) => asPage && `margin-right: 0`};
  }
`
export {
  StyledForm,
  StyledField,
  StyledInput,
  StyledLabel,
  StyledTextarea,
  StyledButton,
  StyledError,
  StyledPhoneInput,
  StyledPhoneInputCountry,
  StyledCountrySelect,
  StyledButtonWrapper,
  StyledVisuallyHiddenLabel,
}
